import React, { useState } from "react";
import { keyframes, Stack } from "@mui/material";
import "./SearchHeader.css";
import "date-fns";
import DefaultDatePicker from "../DatePicker/DefaultDatePicker";
import TextInput from "../Input/TextInput";
import { LoadingButton } from "@siba/components";
import { Search } from "react-feather";
import { Controller, useForm } from "react-hook-form";

export interface searchHeaderProps {
    onSearch?: (data: ISearchForm) => Promise<void>;
    hiddenSearchParams?: { name: string; value: string | number | undefined }[];
    additionalSearchParams?: string[];
}

export interface ISearchForm {
    /**
     * Input data query
     */
    // query?: string;
    /**
     * From date Input data query
     */
    fromDate?: Date | undefined;
    /**
     * To date Input data query
     */
    toDate?: Date | undefined;

    [x: string]: any;
}

/**
 * The Search Header panel view
 * @param props
 * @returns
 */
const SearchHeader = (props: searchHeaderProps) => {
    const { onSearch, hiddenSearchParams, additionalSearchParams } = props;
    const [searchForm, setSearchForm] = useState<ISearchForm>({
        fromDate: undefined,
        toDate: undefined
    });

    /**
     * The Search onChange date handler Header panel view
     * @param props
     *
     * Returns void
     * @returns void
     */
    // const handleSearchFormInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    //     const { name, value } = event.target;
    //     setSearchForm({ ...searchForm, [name]: value });
    // };
    const searchFormHandler = useForm();

    const { register, control } = searchFormHandler;
    /**
     * The Search onChange date handler Header panel view
     *
     * Represents the selected record props
     * @param data
     *
     * Represents the name of the element
     * @param name
     *
     * Returns void
     * @returns void
     */
    const handleDateOnChange = (data: Date, name: string) => {
        setSearchForm({ ...searchForm, [name]: data });
    };

    /**
     * save button handler
     */
    const handleSearch = async () => {
        let searchData = JSON.parse(JSON.stringify(searchForm));
        let formHandlerSearchData = searchFormHandler.getValues();
        let additionalValues = {} as { [x: string]: any };

        if (hiddenSearchParams && hiddenSearchParams.length) {
            for (let i in hiddenSearchParams) {
                additionalValues[hiddenSearchParams[i].name] = hiddenSearchParams[i].value;
            }
        }

        searchData = { ...searchData, ...additionalValues, ...formHandlerSearchData };
        /**
         * make sure fromdate is in right format
         */
        if (!(searchData.fromDate == undefined || searchData.fromDate == "")) searchData.fromDate = new Date(searchData.fromDate).toJSON();
        else searchData.toDate = null;

        /**
         * make sure to date is in right format
         */
        if (!(searchData.toDate == undefined || searchData.toDate == "")) searchData.toDate = new Date(searchData.toDate).toJSON();
        else searchData.toDate = null;

        if (onSearch) await onSearch(searchData);
    };

    return (
        <>
            <Stack direction={"row"} spacing={2}>
                {/* <div className="">
                    <TextInput placeholder="Search..." {...register("query")} />
                </div> */}

                <Controller
                    control={control}
                    name="query"
                    render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState }) => (
                        <TextInput
                            placeholder="Search..."
                            name={"query"}
                            onBlur={onBlur} // notify when input is touched
                            onChange={onChange}
                            inputRef={ref}
                        />
                    )}
                />
                {/* {hiddenSearchParams && hiddenSearchParams.map((x, i) => <TextInput key={i} {...register(x.name)} type="hidden" />)} */}
                {additionalSearchParams &&
                    additionalSearchParams.map((x, i) => (
                        <div style={{ width: "150px" }}>
                            <Controller
                                control={control}
                                name={x}
                                render={({ field: { onChange, onBlur, value, name, ref }, fieldState: { invalid, isTouched, isDirty, error }, formState }) => (
                                    <TextInput
                                        name={x}
                                        onBlur={onBlur} // notify when input is touched
                                        onChange={onChange}
                                        inputRef={ref}
                                    />
                                )}
                            />
                        </div>
                    ))}
                <div style={{ width: "150px" }}>
                    <DefaultDatePicker name="fromDate" selected={searchForm.fromDate} onChange={handleDateOnChange} />
                </div>
                <div style={{ width: "150px" }}>
                    <DefaultDatePicker name="toDate" selected={searchForm.toDate} onChange={handleDateOnChange} />
                </div>
                <LoadingButton onClick={handleSearch} id="searchInput" backgroundColor="rgb(78, 160, 247)">
                    <Search size={20} />
                </LoadingButton>
            </Stack>
        </>
    );
};

export default SearchHeader;
